import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../modal/modal.scss';

function DuplicateTemplateDialog({ 
  open, 
  templateName, 
  dialogClose,
  canProceed,
  itemsEqual
}) {
  // if itemsEqual, show a message that the template is already saved

  return (
    <>
      <Modal
        show={open}
        onHide={dialogClose}
        dialogClassName="modal-60w create-modal"
        aria-labelledby="duplicate-template-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title id="duplicate-template-dialog">
            Duplicate Item Template Detected ({templateName})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            
              {
                itemsEqual ? <p>
                An Item Template with the name <strong>'{templateName}'</strong> has already been saved.</p> :
               <p> An Item Template with the name <strong>'{templateName}'</strong> already exists. 
                Please change the name of the template to save.</p>
              }
            
          </div>
          <div className="d-flex justify-content-end mt-4">
            <Button 
              onClick={dialogClose} 
              className="me-3 cancelbtn btn-bg-brand-5 border-0 text-white"
            >
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DuplicateTemplateDialog; 